import { InstallationModuleData, InstallationModuleType } from "@/types";

export default {
  ["PANELS-REGULAR"]: ({
    grid,
    inverterId,
    inverterSerialNumbers,
    inverterConfiguration,
    inverterConfigurationId,
    locationPanels,
    panelId,
    panelOrientation,
    panelsPerRow,
    numberOfPanels,
    numberOfBus,
    rows,
    hasMicroInverters = true
  }: InstallationModuleData) => ({
    grid,
    inverterId,
    inverterSerialNumbers,
    inverterConfiguration,
    inverterConfigurationId,
    locationPanels: locationPanels !== null ? locationPanels : undefined,
    panelId,
    panelOrientation: panelOrientation !== null ? panelOrientation : undefined,
    panelsPerRow,
    numberOfBus,
    rows,
    numberOfPanels,
    hasMicroInverters
  }),

  ["METER-REGULAR"]: ({
    cast4allMeterSerialNumber,
    meterId,
    meterType,
    meterProductionTest,
    meterSerialNumbers,
    meterSerialNumbersEnphaseGateway,
    meterSerialNumbersEnphaseRelay,
    numberOfBus,
    inverterConfiguration,
    inverterConfigurationId,
    inverterSerialNumbers,
    modemSerialNumber,
    dataloggerSerialNumber,
    dataloggerCcSerialNumber,
    communicationModuleSerialNumber,
    batterySerialNumber,
    kwhMeterSerialNumber
  }: InstallationModuleData) => ({
    cast4allMeterSerialNumber,
    meterId,
    meterType,
    meterProductionTest,
    meterSerialNumbers,
    meterSerialNumbersEnphaseGateway,
    meterSerialNumbersEnphaseRelay,
    numberOfBus,
    inverterConfiguration,
    inverterConfigurationId,
    inverterSerialNumbers,
    modemSerialNumber,
    dataloggerSerialNumber,
    dataloggerCcSerialNumber,
    communicationModuleSerialNumber,
    batterySerialNumber,
    kwhMeterSerialNumber
  }),

  ["METER_MAAS-REGULAR"]: ({
    cast4allMeterSerialNumber,
    meterId,
    meterProductionTest,
    meterSerialNumbers,
    numberOfBus
  }: InstallationModuleData) => ({
    cast4allMeterSerialNumber,
    meterId,
    meterProductionTest,
    meterSerialNumbers,
    numberOfBus
  })
} as Record<InstallationModuleType, (data: InstallationModuleData) => InstallationModuleData>;
